<app-page [simpleTopBar]="true" [showBottomBar]="false" [title]="title">
  <transfer-nft-accept
    [transferNFTEntryResponses]="transferNFTEntryResponses"
    [post]="post"
    [postHashHex]="postHashHex"
  ></transfer-nft-accept>
</app-page>
